<template>
  <div :class="checkMobileStatus ? 'mobile-view' : 'web-view'">
    <!--        <div class="container-fluid row" v-if="result">-->
    <!--            {{result}}-->
    <!--        </div>-->
    <div class="feed-box" v-bind:class="[post.PostID]" v-if="!isHome">
      <div v-if="post.PostStatus === 'Draft'" style="text-align: left">
        <div style="width: 100%; background: #eb5757; padding: 5px 10px; color: #ffffff; border-radius: 4px 4px 0px 0px">
          <i class="fa fa-pencil" aria-hidden="true" style="margin-right: 10px"></i>
          <span>Draft</span>
        </div>
      </div>

      <div class="author">
        <div class="profile">
          <img src="../assets/boy.png" v-if="post.ProfileImage === ''" />
          <!--                    <img :src="`data:image/jpg;base64, ${post.ProfileImage}`"-->
          <!--                         v-if="post.ProfileImage"/>-->
          <img :src="post.ProfileImage" :id="'profile_' + post.PostID" crossorigin v-if="post.ProfileImage" />
        </div>

        <div class="feed-heading">
          <span style="font-weight: normal">{{ post.CONname }}</span>
          <small class="date"
            ><i class="fa fa-clock-o" aria-hidden="true"></i>
            {{ convertDatetimeFormat(post.PostCreatedDate) }}
            <!--                        {{post.PostCreatedDate_convert}}-->
          </small>
        </div>

        <el-popover placement="bottom" width="100" trigger="click" class="feed-box__dropdown" v-if="approverPostNotShow && post.PostCreatedBy === feedUserID">
          <button @click="editPost(post)" class="btn btn-link">{{ lang('Edit') }}{{ lang('Post') }}</button>
          <button @click="removePost(post)" class="btn btn-link">{{ lang('Delete') }}{{ lang('Post') }}</button>
          <el-button id="single-post-dropdown" slot="reference"><i class="fa fa-ellipsis-v" aria-hidden="true"></i></el-button>
        </el-popover>
      </div>

      <div class="post-key-tag-container" v-if="!isNull(post.postKeyTag) && userType !== 'Parent'" style="text-align: left">
        <div style="display: inline-block; padding: 0px 5px; color: #0a74b7" v-for="keyTag in post.postKeyTag">
          <span :id="keyTag.PostKeyTagID">#{{ keyTag.PostKeyTagValue }}</span>
        </div>
      </div>

      <div class="image-wrapper" v-if="!isNull(post.postFiles)">
        <ul v-if="!checkMobileStatus" :class="post.postFiles.length === 1 ? 'image-grid-1' : post.postFiles.length === 2 ? 'image-grid-2' : 'image-grid-3'">
          <!--                    @click="showImageModal"-->
          <li
            style="cursor: pointer; background: #222222"
            class="postFile__item"
            v-for="(obj_Images, index) in post.postFiles"
            :key="obj_Images.id"
            :class="[
              {
                isFile:
                  isImageByExt(obj_Images) === false && !isVideo(obj_Images) && !isAudio(obj_Images) && obj_Images.PostItemFileExt.toLowerCase() !== '.pdf',
              },
              { 'image-grid-item-1': index === 0 },
              { 'image-grid-item-2': index === 1 && post.postFiles.length === 2 },
              { 'image-grid-item-2-2': index === 1 && post.postFiles.length > 2 },
              { 'image-grid-item-3': index === 2 },
            ]"
            v-if="index < 3"
          >
            <img
              slot="img"
              class="nonM card-img-top d-block img-fluid"
              crossorigin
              :src="getHelperBase(obj_Images)"
              :id="'ITEMPOSTID_' + obj_Images.PostItemID"
              v-if="isImageByExt(obj_Images)"
              @click="showPreview(index)"
              :alt="post.PostPorDtlTitle"
              style="height: 100%; width: 100%; object-fit: cover"
            />
            <!-- height: 100%; width: auto; margin: 0 auto; object-fit: scale-down; -->

            <!--                        <LazyVideo class="nonM card-img-top d-block img-fluid w-100" v-else-if="isVideo(obj_Images)"-->
            <!--                                   style="object-fit: contain;"-->
            <!--                                   :src="obj_Images.FilePath" controlsList="nodownload" />-->

            <div
              class="nonM card-img-top d-block img-fluid w-100"
              :class="'video-thumbnail-' + obj_Images.PostItemID"
              v-else-if="isVideo(obj_Images)"
              @click="triggerClickVideo(obj_Images, obj_Images.PostItemID)"
            >
              <img
                class="nonM card-img-top d-block img-fluid w-100"
                style="object-fit: contain; height: 100%"
                src="../assets/video-thumbnail.jpg"
                :id="'ITEMPOSTID_' + obj_Images.PostItemID"
              />
              <div class="lds-ellipsis" v-if="videoClick" style="top: 40%">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>

            <!--                        <video class="nonM card-img-top d-block img-fluid w-100" style="object-fit: contain;" preload="none"-->
            <!--                               v-else-if="isVideo(obj_Images)"-->
            <!--                               controls :poster="obj_Images.videoThumbnail" controlsList="nodownload">-->
            <!--                            <source :src="obj_Images.FilePath"-->
            <!--                                    type="video/mp4">-->
            <!--                        </video>-->

            <!--                        <video class="nonM card-img-top d-block img-fluid w-100" controls-->
            <!--                               v-else-if="isVideo(obj_Images)"-->
            <!--                               style="object-fit: contain; padding: 10px; border: 1px solid #ccc;">-->
            <!--                            <source :src="`data:`+obj_Images.PostItemFileType+`;base64, ${obj_Images.PostItemFile}`" :type="obj_Images.PostItemFileType">-->
            <!--                        </video>-->

            <audio
              class="nonM card-img-top d-block img-fluid w-100"
              v-else-if="isAudio(obj_Images)"
              @click="showPreview(index)"
              controls
              style="object-fit: contain"
            >
              <!--                                <source :src="`data:`+obj_File.GalFileType+`;base64, ${obj_File.GalFile}`" :type="obj_File.GalFileType" :alt="obj_File.GalFileName">-->
              <source :src="obj_Images.FilePath" :type="obj_Images.PostItemFileType" />
            </audio>

            <div v-else style="width: 100%; height: 100%; overflow: auto" @click="showPreview(index)">
              <pdf
                class="nonM card-img-top d-block img-fluid"
                v-if="!isImageByExt(obj_Images) && !isVideo(obj_Images) && !isAudio(obj_Images) && obj_Images.PostItemFileExt.toLowerCase() === '.pdf'"
                v-for="i in obj_Images.numPages"
                :key="i"
                :page="i"
                style="display: block; width: 100%"
                :src="obj_Images.pageOfSrc"
              >
              </pdf>
              <!--                            style="height: 100%; overflow-y: auto; overflow-x: hidden;"-->
              <!--                            <a :href="getFile(obj_Images)"-->
              <!--                               :download="`${obj_Images.PostItemID}${obj_Images.PostItemFileExt}`" class="filepath">-->
              <!--                                {{obj_Images.PostItemID}}{{obj_Images.PostItemFileExt}}-->
              <!--                            </a>-->
            </div>
            <!--                        <button v-if="index === 4 || index === Object.keys(post.postFiles).length-1 && index !== 0 " class="postFile-remainingNumber" @click="showImageModal">-->
            <!--                            <span v-if="index !== Object.keys(post.postFiles).length-1 ">+ {{remainingImage}}</span>-->
            <!--                            <span v-if="index === Object.keys(post.postFiles).length-1 ">+</span>-->
            <!--                        </button>-->

            <button v-if="index >= 3 || Object.keys(post.postFiles).length > 3" class="postFile-remainingNumber" @click="showPreview(2)">
              <span>+ {{ Object.keys(post.postFiles).length - 3 }}</span>
            </button>
          </li>
        </ul>
        <b-carousel
          id="carousel1"
          style="text-shadow: 1px 1px 2px #333"
          :controls="post.postFiles.length > 1"
          indicators
          background="#fff"
          :interval="0"
          v-if="checkMobileStatus"
        >
          <div>
            <!--                        :src="getMediumSource(obj_Images)"-->
            <b-carousel-slide v-for="obj_Images of post.postFiles" :key="obj_Images.id">
              <img
                slot="img"
                class="card-img-top d-block img-fluid"
                crossorigin
                :src="obj_Images.FilePath"
                :id="'ITEMPOSTID_' + obj_Images.PostItemID"
                v-if="isImageByExt(obj_Images)"
                :alt="post.PostPorDtlTitle"
                style="position: unset; max-height: 100%; width: auto; object-fit: scale-down"
              />

              <!--                            <LazyVideo slot="img" class="card-img-top d-block img-fluid" v-if="isVideo(obj_Images)"-->
              <!--                                       style=""-->
              <!--                                       :src="obj_Images.FilePath" controlsList="nodownload" />-->

              <div
                slot="img"
                class="card-img-top d-block img-fluid"
                v-if="isVideo(obj_Images)"
                :class="'video-thumbnail-' + obj_Images.PostItemID"
                @click="triggerClickVideo(obj_Images, obj_Images.PostItemID)"
              >
                <img
                  class="nonM card-img-top d-block img-fluid w-100"
                  style="object-fit: contain; height: 100%"
                  src="../assets/video-thumbnail.jpg"
                  :id="'ITEMPOSTID_' + obj_Images.PostItemID"
                />
                <div class="lds-ellipsis" v-if="videoClick" style="top: 40%">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>

              <!--                            <video slot="img" class="card-img-top d-block img-fluid" v-if="isVideo(obj_Images)" preload="none"-->
              <!--                                   controls :poster="obj_Images.videoThumbnail" controlsList="nodownload">-->
              <!--                                <source :src="obj_Images.FilePath"-->
              <!--                                        type="video/mp4">-->
              <!--                            </video>-->

              <!--                            <video slot="img" class="card-img-top d-block img-fluid" controls-->
              <!--                                   v-if="isVideo(obj_Images)" style="margin: 0 auto; width: 70%; height: 100%;">-->
              <!--                                <source :src="`data:`+obj_Images.PostItemFileType+`;base64, ${obj_Images.PostItemFile}`" :type="obj_Images.PostItemFileType">-->
              <!--                            </video>-->

              <audio class="d-block" v-if="isAudio(obj_Images)" controls style="margin: 0 auto; max-width: 100%">
                <!--                                <source :src="`data:`+obj_File.GalFileType+`;base64, ${obj_File.GalFile}`" :type="obj_File.GalFileType" :alt="obj_File.GalFileName">-->
                <source :src="obj_Images.FilePath" :type="obj_Images.PostItemFileType" />
              </audio>

              <!--                            <pdf v-if="!isImageByExt(obj_Images) && !isVideo(obj_Images) && !isAudio(obj_Images) && obj_Images.PostItemFileExt.toLowerCase() === '.pdf'"-->
              <!--                                 :src="`data:`+obj_Images.PostItemFileType+`;base64, ${obj_Images.PostItemFile}`" style="overflow-y: auto; overflow-x: hidden; height: 80%;"></pdf>-->

              <pdf
                v-if="!isImageByExt(obj_Images) && !isVideo(obj_Images) && !isAudio(obj_Images) && obj_Images.PostItemFileExt.toLowerCase() === '.pdf'"
                v-for="i in obj_Images.numPages"
                :key="i"
                :page="i"
                style="display: block; width: 100%; max-height: 100%; overflow: auto"
                :src="obj_Images.pageOfSrc"
              >
              </pdf>
            </b-carousel-slide>
          </div>
        </b-carousel>
      </div>

      <!--            && this.arr_SchIDs.includes('SCH201400000553') M718 -->
      <!--<div-->

      <div
        v-if="
          !isNull(post.postFiles) && userType === 'Parent' && (this.arr_SchIDs.includes('SCH201400000553') || (!isNull(post.St_Pdpa) && post.St_Pdpa === 'Yes'))
        "
        style="margin: 10px 10px; text-align: left"
      >
        <a style="color: #585388; cursor: pointer; font-size: 12px" @click="downloadItem(post.postFiles)">
          <span style="margin-right: 5px"><i class="fa fa-download" aria-hidden="true"></i></span>
          {{ lang('Download') }}
        </a>
      </div>
      <div
        v-if="!isNull(post.postDevelopment)"
        style="text-align: left; background: #f3f6f8; border-radius: 4px; max-height: 200px; overflow: auto; display: none"
      >
        <div style="width: 100%; background: #e5ecf1; padding: 10px">
          <img src="../assets/Vector20.png" style="width: 20px; height: 20px" />
          <span style="vertical-align: text-top; margin-left: 10px; font-weight: bold">{{ lang('Learning Goals') }}</span>
        </div>

        <div style="width: 100%; padding: 5px 10px" v-for="(pDevelopment, pIndex) in post.postDevelopment">
          <img src="../assets/Vector21.png" style="width: 15px; height: 15px" />
          <span style="color: #5c6b77; font-size: 12px; margin-left: 10px">{{ pDevelopment.PostUpLMIndicator }}</span>
        </div>
      </div>

      <div class="lds-ellipsis" v-if="isLoad">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>

      <div class="content" style="position: relative">
        <!--                <p>-->
        <!--                    &lt;!&ndash;<strong class="feed-subtitle"> ADD A NOTE</strong>&ndash;&gt;-->
        <!--                    <span style="white-space: pre-line;">{{post.PostContent}}</span>-->
        <!--                </p>-->

        <!--                width: 80%; padding: 0px 10px 0px 0px;-->
        <div class="" style="">
          <div class="mb-2 border-bottom pb-2 px-3" @click="showPreview(index)">
            <K2Text align="left" class="pointer" bold="true">{{ post.PostUpdDtlTitle }}</K2Text>
          </div>

          <p style="font-size: 14px">
            <!--                        <span style="white-space: pre-line;">{{post.PostContent}}</span>-->
            <span class="post-content" style="white-space: pre-line; word-break: break-word" v-html="post.PostContent"></span>
          </p>
        </div>

        <!--                <div class="reaction-function-container" v-if="!hideComment">-->
        <!--                    <div class="moreAction" @mouseover="isHoverReaction = true"-->
        <!--                         @mouseleave="isHoverReaction = false">-->
        <!--                    <span class="reaction-popover" v-for="eachSelected of obj_SelectedReaction"-->
        <!--                          v-if="obj_SelectedReaction.length > 0 && eachSelected.PoReaRelatedPostID === post.PostID">-->

        <!--                        <input :id="post.PostID+'-'+eachSelected.PoReaType" type="checkbox" @change="togglePostReaction"-->
        <!--                               :value="eachSelected.PoReaType" :checked="getUserSelectedReaction(eachSelected.PoReaType)" hidden="hidden">-->
        <!--                        <label :for="post.PostID+'-'+eachSelected.PoReaType" class="reaction-label" style="font-size: 12px;">-->
        <!--                            <div :id="eachSelected.PoReaType">-->
        <!--                                <img class="selected-reaction-icon" :src="checkReactionIcon(eachSelected.PoReaType)"/>-->
        <!--                                <span style="margin-left: 5px;">{{checkReactionIconName(eachSelected.PoReaType)}}</span>-->
        <!--                            </div>-->
        <!--                        </label>-->
        <!--                    </span>-->

        <!--                        <span class="reaction-popover" v-if="obj_SelectedReaction.length <= 0">-->
        <!--                        <input :id="post.PostID+'-LIKE-default'" type="checkbox" @change="togglePostReaction" value="LIKE" hidden="hidden">-->
        <!--                        <label :for="post.PostID+'-LIKE-default'" class="reaction-label" style="font-weight: normal; font-size: 12px;"><i class="fa fa-thumbs-o-up" aria-hidden="true" style="margin-right: 5px;"></i>{{lang("LIKE")}}</label>-->
        <!--                    </span>-->

        <!--                        &lt;!&ndash;                reaction list&ndash;&gt;-->
        <!--                        <div class="reaction-list-container" v-show="isHoverReaction">-->
        <!--                            <div class="single-reaction" :class="eachReaction.reactionName.toLowerCase()+'-reaction'"-->
        <!--                                 v-for="eachReaction of arrobj_ReactionList">-->
        <!--                                <input :id="post.PostID+'-'+eachReaction.reactionName" type="checkbox" @change="togglePostReaction"-->
        <!--                                       :value="eachReaction.reactionName" :checked="getUserSelectedReaction(eachReaction.reactionName)" hidden="hidden">-->
        <!--                                <label :for="post.PostID+'-'+eachReaction.reactionName">-->
        <!--                                    <img :src="eachReaction.reactionIcon">-->
        <!--                                    <p>{{eachReaction.reactionNameCN}}</p>-->
        <!--                                </label>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </div>-->
      </div>

      <div class="" style="padding: 0px 10px 0px 10px" v-if="post.PostBroadDtlMsg">
        <p style="font-size: 14px">
          <span style="white-space: pre-line">{{ post.PostBroadDtlMsg }}</span>
        </p>
      </div>

      <div class="total-reaction-container" v-if="!hideComment">
        <!--                {{post.postReaction}} -->
        <div style="display: inline-block; margin-right: 5px" v-if="!isNull(post.postReaction)">
          <img
            class="total-reaction-img-list"
            crossorigin
            v-if="post.postReaction.length > 0"
            v-for="(eachReaction, eachKey) of reactionGroupby(post.postReaction, 'PoReaType')"
            :src="checkReactionIcon(eachKey)"
          />

          <span @click="showReactionModal()" style="margin-left: 5px; cursor: pointer">
            <div v-for="(eachReaction, eachKey) in post.postReaction" style="display: inline-block; color: grey; font-size: 11px">
              <span v-if="eachKey < 3">{{ eachReaction.CONname }}<span v-if="post.postReaction.length > eachKey + 1">, </span></span>
              <!--                            <span v-if="eachKey > 2">{{(post.postReaction.length - 3)}} more</span>-->
            </div>
            <span v-if="post.postReaction.length > 3" style="color: grey; font-size: 11px">{{ post.postReaction.length - 3 }} more</span>
          </span>

          <!--                    <span style="margin-left: 5px; color: #9a9a9a; cursor: pointer;" @click="showReactionModal()">{{post.postReaction.length}}</span>-->
        </div>

        <div style="display: inline-block" v-if="!isNull(post.postSeen) && userType !== 'Parent'">
          <span @click="showPostSeenModal()" style="cursor: pointer; font-size: 12px; color: grey">
            <span v-if="!isNull(post.postReaction)">| </span>
            {{ lang('Seen by') }} {{ post.postSeen.length }}
          </span>
        </div>

        <div style="display: inline-block" v-if="isNull(post.postReaction)"></div>

        <span class="comment-count" v-if="post.PostAllowComment === 'Yes'">
          <!--                    <i class="material-icons commentCount">-->
          <!--                        chat_bubble_outline-->
          <!--                    </i>-->
          <span style="font-size: 12px">{{ commentCount }} comment(s)</span>
        </span>

        <!--                <hr style="margin-bottom: 0px;" />-->

        <div
          class="reaction-function-container"
          v-if="!hideComment"
          :class="!isNull(post.postReaction) || (!isNull(post.postSeen) && userType !== 'Parent') ? '' : 'left'"
        >
          <div class="moreAction" @mouseover="isHoverReaction = true" @mouseleave="isHoverReaction = false">
            <span
              class="reaction-popover"
              v-for="eachSelected of obj_SelectedReaction"
              v-if="obj_SelectedReaction.length > 0 && eachSelected.PoReaRelatedPostID === post.PostID"
            >
              <input
                :id="post.PostID + '-' + eachSelected.PoReaType"
                type="checkbox"
                @change="togglePostReaction"
                :value="eachSelected.PoReaType"
                :checked="getUserSelectedReaction(eachSelected.PoReaType)"
                hidden="hidden"
              />
              <label :for="post.PostID + '-' + eachSelected.PoReaType" class="reaction-label" style="font-size: 12px">
                <div :id="eachSelected.PoReaType">
                  <img class="selected-reaction-icon" :src="checkReactionIcon(eachSelected.PoReaType)" crossorigin />
                  <span style="margin-left: 5px">{{ checkReactionIconName(eachSelected.PoReaType) }}</span>
                </div>
              </label>
            </span>

            <span class="reaction-popover" v-if="obj_SelectedReaction.length <= 0">
              <input :id="post.PostID + '-LIKE-default'" type="checkbox" @change="togglePostReaction" value="LIKE" hidden="hidden" />
              <label :for="post.PostID + '-LIKE-default'" class="reaction-label" style="font-weight: normal; font-size: 12px"
                ><i class="fa fa-thumbs-o-up" aria-hidden="true" style="margin-right: 5px"></i>{{ lang('LIKE') }}</label
              >
            </span>

            <!--                reaction list-->
            <div class="reaction-list-container" v-show="isHoverReaction">
              <div class="single-reaction" :class="eachReaction.reactionName.toLowerCase() + '-reaction'" v-for="eachReaction of arrobj_ReactionList">
                <input
                  :id="post.PostID + '-' + eachReaction.reactionName"
                  type="checkbox"
                  @change="togglePostReaction"
                  :value="eachReaction.reactionName"
                  :checked="getUserSelectedReaction(eachReaction.reactionName)"
                  hidden="hidden"
                />
                <label :for="post.PostID + '-' + eachReaction.reactionName">
                  <img :src="eachReaction.reactionIcon" crossorigin />
                  <p>{{ eachReaction.reactionNameCN }}</p>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="dm-container" v-if="userType === 'Parent' && post.PostType !== 'Broadcast'">
        <div class="input-group">
          <input class="form-control" v-model="parentDMMsg" type="text" placeholder="Please enter message" style="" />
          <div class="input-group-append" style="cursor: pointer" @click="submitDM(post)">
            <span class="btn btn-dm-submit-icon" style="background: #426dff; color: #ffffff">
              <i class="fa fa-paper-plane"></i>
            </span>
          </div>
        </div>
      </div>

      <!--            <div>-->
      <!--                <div class="moreAction" @mouseover="isHoverReaction = true"-->
      <!--                     @mouseleave="isHoverReaction = false">-->
      <!--                    <span class="reaction-popover" v-for="eachSelected of obj_SelectedReaction"-->
      <!--                          v-if="obj_SelectedReaction.length > 0 && eachSelected.PoReaRelatedPostID === post.PostID">-->

      <!--                        <input :id="post.PostID+'-'+eachSelected.PoReaType" type="checkbox" @change="togglePostReaction"-->
      <!--                               :value="eachSelected.PoReaType" :checked="getUserSelectedReaction(eachSelected.PoReaType)" hidden="hidden">-->
      <!--                        <label :for="post.PostID+'-'+eachSelected.PoReaType" class="reaction-label" style="font-size: 12px;">-->
      <!--                            <div :id="eachSelected.PoReaType">-->
      <!--                                <img class="selected-reaction-icon" :src="checkReactionIcon(eachSelected.PoReaType)"/>-->
      <!--                                <span style="margin-left: 5px;">{{checkReactionIconName(eachSelected.PoReaType)}}</span>-->
      <!--                            </div>-->
      <!--                        </label>-->
      <!--                    </span>-->

      <!--                    <span class="reaction-popover" v-if="obj_SelectedReaction.length <= 0">-->
      <!--                        <input :id="post.PostID+'-LIKE-default'" type="checkbox" @change="togglePostReaction" value="LIKE" hidden="hidden">-->
      <!--                        <label :for="post.PostID+'-LIKE-default'" class="reaction-label" style="font-weight: normal; font-size: 12px;"><i class="fa fa-thumbs-o-up" aria-hidden="true" style="margin-right: 5px;"></i>{{lang("LIKE")}}</label>-->
      <!--                    </span>-->

      <!--                    &lt;!&ndash;                reaction list&ndash;&gt;-->
      <!--                    <div class="reaction-list-container" v-show="isHoverReaction">-->
      <!--                        <div class="single-reaction" :class="eachReaction.reactionName.toLowerCase()+'-reaction'"-->
      <!--                             v-for="eachReaction of arrobj_ReactionList">-->
      <!--                            <input :id="post.PostID+'-'+eachReaction.reactionName" type="checkbox" @change="togglePostReaction"-->
      <!--                                   :value="eachReaction.reactionName" :checked="getUserSelectedReaction(eachReaction.reactionName)" hidden="hidden">-->
      <!--                            <label :for="post.PostID+'-'+eachReaction.reactionName">-->
      <!--                                <img :src="eachReaction.reactionIcon">-->
      <!--                                <p>{{eachReaction.reactionNameCN}}</p>-->
      <!--                            </label>-->
      <!--                        </div>-->
      <!--                    </div>-->
      <!--                </div>-->
      <!--            </div>-->

      <div class="comment_wrapper transition-box" v-if="!hideComment && post.PostAllowComment === 'Yes'" style="display: none">
        <!--                <span class="float-right ml-2 post-icon-btn" ><i-->
        <!--                        class="material-icons commentCount">-->
        <!--                    chat_bubble_outline-->
        <!--                </i>-->
        <!--                    {{commentCount}}-->
        <!--                </span>-->
        <form class="form-style">
          <input type="text" class="form-control d-none commentPostID" v-model="commentPostID" />
          <vs-input :label-placeholder="lang('Comment')" v-model="commentPostContent" class="addComment" v-on:keyup.enter="submitComment(post.PostID)" />
          <div class="btn btn-primary" @click="submitComment(post.PostID)"><i class="fa fa-paper-plane" aria-hidden="true"></i></div>
        </form>
        <div class="commentWrap" v-if="post.commentItems" :class="{ 'is-collapsed': post.collapsed }">
          <transition-group name="top">
            <div
              class="comment__item"
              v-if="post.commentItems && commentIndex <= post.commentItems.length && post.commentItems[commentIndex - 1]"
              v-for="commentIndex in commentsToShow"
              :key="post.commentItems[commentIndex - 1].PoCmID"
              style="position: relative"
            >
              <!--<div class="comment__item" v-for="commentItem of post.commentItems"-->
              <!--:key="commentItem.PoCmID">-->
              <!--                            <div class="commentProfile col-md-2">-->
              <!--                                <img src="../assets/boy.png" v-if="post.commentItems[commentIndex-1].ProfileImage === ''">-->
              <!--                                <img :src="`data:image/jpg;base64, ${post.commentItems[commentIndex-1].ProfileImage}`"-->
              <!--                                     v-if="post.commentItems[commentIndex-1].ProfileImage"/>-->
              <!--                            </div>-->

              <div class="rightCommentContainer col-md-12">
                <div class="commentItem__header">
                  <div class="comment__name">
                    <span>{{ post.commentItems[commentIndex - 1].commentOwnerName }}</span>
                    <!--                                    commentOwnerName-->
                  </div>

                  <div class="commentPostContent_show" v-if="checkidcomment !== post.commentItems[commentIndex - 1].PoCmID">
                    {{ post.commentItems[commentIndex - 1].PoCmContent }}
                  </div>

                  <div class="comment__date">
                    <div class="post-comment-actionGroup" v-if="post.commentItems[commentIndex - 1].CONid === feedUserID">
                      <el-button
                        class="save"
                        type="text"
                        slot="reference"
                        @click="saveClick(post.commentItems[commentIndex - 1].PoCmID, post.commentItems[commentIndex - 1].PoCmContent)"
                        :class="{ 'd-none': readonly === true || checkidcomment !== post.commentItems[commentIndex - 1].PoCmID }"
                      >
                        {{ lang('Save') }}
                      </el-button>
                      <el-button class="edit" type="text" slot="reference" @click="editClick(post.commentItems[commentIndex - 1].PoCmID)" v-if="showEdit">
                        {{ lang('Edit') }}
                      </el-button>
                      .
                      <el-button
                        class="delete"
                        type="text"
                        slot="reference"
                        @click="
                          emitShowDeleteModal(post.commentItems[commentIndex - 1].PoCmID, post.commentItems[commentIndex - 1].PoCmContent, post.PostID, post)
                        "
                      >
                        {{ lang('Delete') }}
                      </el-button>
                      .
                      <!--                                        <AlertComponent :showModal="deleteModalShow" @cancelClick="closeDeleteModal"-->
                      <!--                                                        @okClick="deleteComment"/>-->
                    </div>
                    <span>{{ post.commentItems[commentIndex - 1].PoCmCreatedDate_convert }}</span>
                  </div>
                </div>
                <!--                                <div class="commentPostContent_show" v-if="checkidcomment !== post.commentItems[commentIndex-1].PoCmID">-->
                <!--                                    {{post.commentItems[commentIndex-1].PoCmContent}}-->
                <!--                                </div>-->
                <textarea
                  v-if="readonly === false && checkidcomment === post.commentItems[commentIndex - 1].PoCmID"
                  type="text"
                  class="comment__content"
                  id="commentPostContent"
                  v-model="post.commentItems[commentIndex - 1].PoCmContent"
                  v-bind:readonly="readonly"
                  :class="{ editable: readonly === false && checkidcomment === post.commentItems[commentIndex - 1].PoCmID }"
                ></textarea>

                <div
                  @mouseover="mouseOverComment(post.commentItems[commentIndex - 1].PoCmID)"
                  @mouseleave="mouseLeaveComment(post.commentItems[commentIndex - 1].PoCmID)"
                  style="position: relative"
                >
                  <div :class="post.commentItems[commentIndex - 1].PoCmID + 'comment-reaction-container'" style="display: inline-block; padding-right: 5px">
                    <span class="comment-reaction-popover">
                      <input
                        :id="post.commentItems[commentIndex - 1].PoCmID + '-LIKE'"
                        type="checkbox"
                        @change="toggleCommentReaction($event, post.commentItems[commentIndex - 1])"
                        value="LIKE"
                        hidden="hidden"
                      />
                      <label
                        :for="post.commentItems[commentIndex - 1].PoCmID + '-LIKE'"
                        :class="
                          post.commentItems[commentIndex - 1].commentReactions
                            ? post.commentItems[commentIndex - 1].commentReactions.commentReactionSelected
                              ? 'comment-selected'
                              : ''
                            : ''
                        "
                        >{{ lang('LIKE') }}</label
                      >
                    </span>
                  </div>

                  <div class="total-each-comment-reaction" v-if="post.commentItems[commentIndex - 1].commentReactions">
                    <img
                      style="width: 20px; background: transparent"
                      crossorigin
                      v-if="post.commentItems[commentIndex - 1].commentReactions.length > 0"
                      v-for="(eachCommentReactionSelected, eachCommentKey) of reactionGroupby(
                        post.commentItems[commentIndex - 1].commentReactions,
                        'PoReaType'
                      )"
                      :src="checkReactionIcon(eachCommentKey)"
                    />

                    <span style="margin-left: 5px; color: #9a9a9a">{{ post.commentItems[commentIndex - 1].commentReactions.length }}</span>
                  </div>

                  <div class="comment-reaction-list-container" :id="post.commentItems[commentIndex - 1].PoCmID + '-comment-reaction-list'">
                    <div
                      class="single-comment-reaction"
                      :class="eachReaction.reactionName.toLowerCase() + '-reaction'"
                      v-for="eachReaction of arrobj_ReactionList"
                    >
                      <input
                        :id="post.commentItems[commentIndex - 1].PoCmID + '-' + eachReaction.reactionName"
                        type="checkbox"
                        @change="toggleCommentReaction($event, post.commentItems[commentIndex - 1])"
                        :value="eachReaction.reactionName"
                        :checked="getUserSelectedCommentReaction(eachReaction.reactionName, post.commentItems[commentIndex - 1])"
                        hidden="hidden"
                      />
                      <label :for="post.commentItems[commentIndex - 1].PoCmID + '-' + eachReaction.reactionName">
                        <img :src="eachReaction.reactionIcon" crossorigin />
                        <p>{{ eachReaction.reactionNameCN }}</p>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition-group>
          <button @click="commentsToShow += 2" v-if="post.commentItems && post.commentItems.length > commentsToShow">
            {{ lang('Load More') }}
          </button>
        </div>
      </div>
      <!--            <div class="postFile" v-if="!isNull(post.postFiles)">-->
      <!--                <div class="postFile__item" v-for="postFile in post.postFiles" :key="postFile.ID">-->
      <!--                    &lt;!&ndash;<img :src="postFile.PostItemPath" :class="{'post-disabled':postFile.PostItemStatus !=='Active'}"/>&ndash;&gt;-->
      <!--                    <a v-if="!postFile.PostItemFile && !checkIfImage(postFile.PostItemPath)"-->
      <!--                       v-bind:href="[postFile.PostItemPath]"-->
      <!--                       :class="{'post-disabled':postFile.PostItemStatus !=='Active'}">-->
      <!--                        <i class="fa fa-file" aria-hidden="true"></i>-->
      <!--                        {{postFile.PostItemPostID}}-->
      <!--                    </a>-->
      <!--                    &lt;!&ndash;{{postFile.PostItemCreatedDate}}&ndash;&gt;-->
      <!--                </div>-->
      <!--            </div>-->
    </div>
    <ul class="feed-box" v-bind:class="[post.PostID]" v-if="isHome">
      <li>
        <div class="image-wrapper">
          <ul>
            <li class="" v-for="postFile in post.postFiles" :key="postFile.ID">
              <img
                :src="`data:image/jpg;base64, ${postFile.PostItemFile}`"
                crossorigin
                :class="{ 'post-disabled': postFile.PostItemStatus !== 'Active' }"
                v-if="postFile.PostItemFile"
              />
              <img
                :src="postFile.PostItemPath"
                crossorigin
                :class="{ 'post-disabled': postFile.PostItemStatus !== 'Active' }"
                v-else-if="checkIfImage(postFile.PostItemPath)"
              />
            </li>
          </ul>
        </div>
        <span>
          <strong>{{ post.CONname }}</strong>
          <small class="date">
            <i class="fa fa-clock-o" aria-hidden="true"></i>
            {{ post.PostCreatedDate }}
          </small>
          {{ post.PostContent }}
        </span>
      </li>
    </ul>

    <b-modal id="modal_EditComponent" ref="modal_EditComponent" size="lg" hide-footer :title="lang('Edit') + lang('Post')" @hidden="hideEditModal">
      <component @result="displayResult" :is="obj_SelectedComponent" :post="post"></component>
    </b-modal>
    <b-modal id="imageModal" ref="imageModal" hide-footer hide-header>
      <div style="text-align: right">
        <span @click="hideImageModal()" style="display: inline-block; padding: 0px 5px; font-weight: bold; cursor: pointer">Close</span>
      </div>

      <div v-for="(obj_Images, imgIndex) of post.postFiles" :key="obj_Images.id">
        <div v-if="obj_Images.isSlide">
          <div class="mySlides">
            <img
              slot="img"
              class="card-img-top d-block img-fluid"
              crossorigin
              :src="obj_Images.FilePath"
              v-if="isImageByExt(obj_Images)"
              :alt="post.PostPorDtlTitle"
              style="max-height: 100%; height: 100%; width: auto; object-fit: scale-down; margin: 0 auto"
            />

            <LazyVideo
              slot="img"
              class="card-img-top d-block img-fluid"
              v-if="isVideo(obj_Images)"
              style="height: 100%; margin: 0 auto"
              :src="obj_Images.FilePath"
              controlsList="nodownload"
            />

            <audio class="d-block" v-if="isAudio(obj_Images)" controls style="margin: 0 auto; max-width: 100%">
              <source :src="obj_Images.FilePath" :type="obj_Images.PostItemFileType" />
            </audio>

            <pdf
              v-if="!isImageByExt(obj_Images) && !isVideo(obj_Images) && !isAudio(obj_Images) && obj_Images.PostItemFileExt.toLowerCase() === '.pdf'"
              v-for="i in obj_Images.numPages"
              :key="i"
              :page="i"
              style="display: block; width: 100%; margin: 0 auto"
              :src="obj_Images.pageOfSrc"
            >
            </pdf>
          </div>

          <div class="row" style="justify-content: center; margin: 10px 0px 0px 0px">
            <div style="margin: 7px 0px; font-weight: bold; color: #2b2626">{{ imgIndex + 1 }}/{{ post.postFiles.length }}</div>
            <button class="btn" @click="showDivs('prev')"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>
            <button class="btn" @click="showDivs('next')"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>
            <button
              class="btn"
              @click="downloadSingleItem(obj_Images)"
              v-if="
                !isNull(post.postFiles) &&
                userType === 'Parent' &&
                (arr_SchIDs.includes('SCH201400000553') || (!isNull(post.St_Pdpa) && post.St_Pdpa === 'Yes'))
              "
            >
              <i class="fa fa-download" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="imageModal-1" ref="imageModal-1" hide-footer hide-header>
      <b-carousel
        id="modal_carousel"
        :value="imgModalSlide"
        style="text-shadow: 1px 1px 2px #333"
        :controls="post.postFiles && post.postFiles.length > 1"
        indicators
        background="#fff"
        :interval="0"
      >
        <div>
          <!--                    :src="getMediumSource(obj_Images)"-->
          <b-carousel-slide v-for="obj_Images of post.postFiles" :key="obj_Images.id">
            <button
              v-if="
                !isNull(post.postFiles) &&
                userType === 'Parent' &&
                (arr_SchIDs.includes('SCH201400000553') || (!isNull(post.St_Pdpa) && post.St_Pdpa === 'Yes'))
              "
              @click="downloadSingleItem(obj_Images)"
              class="btn-single-download btn"
            >
              {{ lang('Download') }}
            </button>
            <img
              slot="img"
              class="card-img-top d-block img-fluid"
              :src="obj_Images.FilePath"
              crossorigin
              v-if="isImageByExt(obj_Images)"
              :alt="post.PostPorDtlTitle"
              style="max-height: 100%; height: 100%; width: auto; object-fit: scale-down"
            />

            <LazyVideo
              slot="img"
              class="card-img-top d-block img-fluid"
              v-if="isVideo(obj_Images)"
              style="height: 100%"
              :src="obj_Images.FilePath"
              controlsList="nodownload"
            />

            <!--                        <video slot="img" class="card-img-top d-block img-fluid" controls-->
            <!--                               v-if="isVideo(obj_Images)" style="margin: 0 auto; width: 70%; height: 100%;">-->
            <!--                            <source :src="`data:`+obj_Images.PostItemFileType+`;base64, ${obj_Images.PostItemFile}`" :type="obj_Images.PostItemFileType">-->
            <!--                        </video>-->

            <audio class="d-block" v-if="isAudio(obj_Images)" controls style="margin: 0 auto; max-width: 100%">
              <!--                                <source :src="`data:`+obj_File.GalFileType+`;base64, ${obj_File.GalFile}`" :type="obj_File.GalFileType" :alt="obj_File.GalFileName">-->
              <source :src="obj_Images.FilePath" :type="obj_Images.PostItemFileType" />
            </audio>

            <!--                        <pdf slot="img" class="card-img-top d-block img-fluid" v-if="!isImageByExt(obj_Images) && !isVideo(obj_Images) && !isAudio(obj_Images) && obj_Images.PostItemFileExt.toLowerCase() === '.pdf'"-->
            <!--                             :src="`data:`+obj_Images.PostItemFileType+`;base64, ${obj_Images.PostItemFile}`" style="height: 100%; overflow-y: auto; overflow-x: hidden;"></pdf>-->
            <pdf
              v-if="!isImageByExt(obj_Images) && !isVideo(obj_Images) && !isAudio(obj_Images) && obj_Images.PostItemFileExt.toLowerCase() === '.pdf'"
              v-for="i in obj_Images.numPages"
              :key="i"
              :page="i"
              style="display: block; width: 100%"
              :src="obj_Images.pageOfSrc"
            >
            </pdf>
          </b-carousel-slide>
        </div>
      </b-carousel>
    </b-modal>

    <b-modal id="reactionModal" ref="reactionModal" size="sm" hide-footer title="Reaction by" @hidden="hideReactionModal">
      <div v-for="reaction in post.postReaction" style="margin-bottom: 20px; border-bottom: 1px solid #f7f7f7; padding: 5px">
        <!--                <img class="reaction-each-profile-img" src=""/>-->
        <!--                <img style="width: 50px; height: 50px; border-radius: 50%; margin-right: 10px;"-->
        <!--                     src="../assets/boy.png" v-if="post.ProfileImage === ''">-->
        <!--                <img style="width: 50px; height: 50px; border-radius: 50%; margin-right: 10px;"-->
        <!--                     :src="`data:image/jpg;base64, ${post.ProfileImage}`"-->
        <!--                     v-if="post.ProfileImage"/>-->
        <span>{{ reaction.CONname }}</span>
        <img class="total-reaction-img-list" style="float: right" crossorigin :src="checkReactionIcon(reaction.PoReaType)" />
      </div>
    </b-modal>

    <b-modal id="postSeenModal" ref="postSeenModal" size="sm" hide-footer :title="lang('Seen by')" @hidden="hidePostSeenModal">
      <div v-for="seen in post.postSeen" style="margin-bottom: 20px; border-bottom: 1px solid #f7f7f7; padding: 5px">
        <div class="row" style="margin: 0px">
          <span>{{ seen.CONname }}</span>
          <!--                    <span style="margin-left: auto;">{{seen.NotiModifiedOn_convert}}</span>-->
        </div>
      </div>
    </b-modal>

    <b-modal id="postDevelopmentModal" ref="postDevelopmentModal" size="sm" hide-footer :title="lang('Developmental Goals')" @hidden="hidePostDevelopmentModal">
      <div v-if="!isNull(post.postDevelopment)" style="margin-bottom: 20px; border-bottom: 1px solid #f7f7f7; padding: 5px">
        <table>
          <tr>
            <th>{{ lang('NO') }}</th>
            <th>{{ lang('Goals') }}</th>
          </tr>
          <tr v-for="(porDev, porIndex) in post.postDevelopment">
            <td>{{ porIndex + 1 }}</td>
            <td>{{ porDev.PostUpLMIndicator }}</td>
          </tr>
        </table>
      </div>

      <!--            <div>-->
      <!--                <div v-if="!isNull(post.postDevelopment)">-->
      <!--                    <data-tables :data="post.postDevelopment">-->
      <!--                        <el-table-column v-for="porDev in porDevelopmentObjectValue" :prop="porDev.prop"-->
      <!--                                         :label="porDev.label" :key="porDev.prop"-->
      <!--                                         sortable="custom">-->
      <!--                        </el-table-column>-->
      <!--                    </data-tables>-->
      <!--                </div>-->
      <!--            </div>-->
    </b-modal>
    <ActivityPreview isPublished="true" :parentPost="previewPost" :modal="modal" @handleClose="handleClose" />
  </div>
</template>

<script>
import isImage from 'is-image'

import * as jQuery from './signalR/jquery-3.5.1'
import * as signalR from './signalR/jquery.signalR-2.4.1'

import DataSource from '../data/datasource'
import AlertComponent from './alertComponent'
import portfolio from '../components/Post_Portfolio_Component'
import updates from '../components/Post_Updates_Component'
import broadcast from '../components/Post_Broadcast_Component.vue'
import Cookies from 'js-cookie'
import { lang } from '../locale/index'
import moment from 'moment'
import $ from 'jquery'

import reactionLike from '../assets/like.gif'
import reactionLove from '../assets/love.gif'
import reactionWow from '../assets/oo.gif'
import reactionFunny from '../assets/funny.gif'
import reactionSad from '../assets/sad.gif'

import pdf from 'vue-pdf'

import Vue from 'vue'
import VueLazyLoadVideo from 'vue-lazyload-video'
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import * as axios from 'axios'
import K2Modal from '../uiComponents/k2Modal/k2Modal'
import K2Row from '../uiComponents/k2Row/k2Row'
import K2Icon from '../uiComponents/k2Icon/k2MAIcon'
import K2Heading from '../uiComponents/k2Heading/k2Heading'
import K2Confirm from '../uiComponents/k2Confirm/k2Confirm'
import ActivityPreview from '../pages/activity/component/PublishedComponent/activityPreview.vue'
import K2Text from '@/uiComponents/k2Text/k2Text'
import { getActivityImageBase } from '@/helper/util_custom'

Vue.use(VueLazyLoadVideo)

export default {
  name: 'singleFeedComponent',
  components: { K2Text, ActivityPreview, K2Confirm, K2Heading, K2Icon, K2Row, K2Modal, AlertComponent, updates, portfolio, pdf },
  data() {
    return {
      reactionCount2: '',
      commentCount: '',
      show3: false,
      commentPostContent: '',
      readonly: '',
      checkidcomment: null,
      systemmsgError: null,
      commentPostID: '',
      deleteModalShow: false,
      showEdit: true,
      deleteCmId: null,
      deleteCmContent: null,
      deleteCmPostId: null,
      deletePostModalShow: false,
      obj_SelectedComponent: false,
      result: '',
      post: [
        {
          CONname: '',
          PostContent: '',
          PostCreatedBy: '',
          PostCreatedDate: '',
          PostID: '',
          PostType: '',
          PostUpdDtlDescription: '',
          ProfileImage: '',
          RowNumber: '',
          collapsed: true,
          commentItems: [],
          commentPostID: '',
          postFiles: '',
          postReaction: [],
          countImageFile: '',
          postKeyTag: [],
          postDevelopment: [],
          postSeen: [],
        },
      ],
      str_TimerID: '',
      likeCount: 0,
      isFile: false,
      approverPostNotShow: true,
      remainingImage: '',

      feedUserID: Cookies.get('userIDSession'),
      commentsToShow: 2,

      isHoverReaction: false,
      arrobj_ReactionList: [
        {
          reactionName: 'LIKE',
          reactionNameCN: lang('LIKE'),
          reactionIcon: reactionLike,
          isCheck: false,
        },
        {
          reactionName: 'LOVE',
          reactionNameCN: lang('LOVE'),
          reactionIcon: reactionLove,
          isCheck: false,
        },
        {
          reactionName: 'WOW',
          reactionNameCN: lang('WOW'),
          reactionIcon: reactionWow,
          isCheck: false,
        },
        {
          reactionName: 'HAHA',
          reactionNameCN: lang('HAHA'),
          reactionIcon: reactionFunny,
          isCheck: false,
        },
        // {"reactionName": "SAD", "reactionNameCN": lang("SAD"), "reactionIcon": reactionSad, "isCheck": false}
      ],
      obj_SelectedReaction: [],
      reactionSelectedText: '',

      obj_SelectedCommentReaction: [],
      totalReactionList: [],
      commentReactionSelected: 0,

      notificationUserToken: '',
      checkMobileStatus: false,

      isLoad: false,
      userType: '',
      parentDMMsg: '',
      singlePostLink: '',
      arr_SchIDs: [],

      videoClick: false,

      porDevelopmentObjectValue: [
        // {
        //     prop: "Domain",
        //     label: lang("Domain")
        // },
        {
          prop: 'PostUpLMIndicator',
          label: lang('Goals'),
        },
        // {
        //     prop: "Indicator",
        //     label: lang("Indicator")
        // }
      ],

      imgModalSlide: 0,
      currentSlide: 1,
      modal: null,
      previewPost: null,
    }
  },
  mounted() {
    if (!this.isNull(this.approverPost) && this.approverPost === 'YES') {
      this.approverPostNotShow = false
    }

    if (!this.isNull(this.parentPost)) {
      this.initPost()
    }

    $(document)
      .off('contextmenu', 'video')
      .on('contextmenu', 'video', e => {
        e.preventDefault()
      })

    this.isMobile()
  },
  props: ['parentPost', 'commentitemSubmit', 'hideComment', 'isHome', 'hideSubmenu', 'loadPost', 'approverPost', 'index', 'sendMsg'],
  methods: {
    lang,
    sleep(milliseconds) {
      return new Promise(resolve => setTimeout(resolve, milliseconds))
    },
    getBCMsg(postId) {
      this.initPost()

      this.getComment()
      this.showCommentTransition(postId)
      console.log('i got it!! id:' + postId)
    },
    showImageModal(imgIndex) {
      if (!this.isNull(this.post.postFiles)) {
        this.post.postFiles.forEach(pdfFiles => {
          if (pdfFiles.PostItemFileExt.toLowerCase() === '.pdf') {
            let src = pdf.createLoadingTask(pdfFiles.FilePath)
            pdfFiles.pageOfSrc = src
            src.promise.then(pdf => {
              pdfFiles.numPages = pdf.numPages
            })
          }
        })
      }

      if (imgIndex !== '') {
        this.imgModalSlide = imgIndex
        this.showDivs('default')
      }

      this.$refs['imageModal'].show()
    },
    showPreview(imgIndex) {
      if (this.post.postFiles && this.post.postFiles.length > 0) {
        // this.post.postFiles.forEach(d => {
        //   d.url = d.oriFilePath;
        // });
      }

      if (this.post.PostType === 'Update') {
        this.post.PostType = 'Feed'
      }
      this.post.studentList = this.studentList
      this.post.classList = this.classList
      this.post.levelList = this.levelList
      this.post.school = this.school
      this.previewPost = this.post
      this.modal = 'preview'
    },
    handleClose() {
      this.modal = null
      this.previewPost = null
    },
    hideImageModal() {
      this.imgModalSlide = 0
      this.$refs['imageModal'].hide()
    },
    checkIfImage(file) {
      return isImage(file)
    },
    isMobile() {
      let screenWidth = window.innerWidth
      if (screenWidth <= 770) {
        this.checkMobileStatus = true
        // return true;
      } else {
        this.checkMobileStatus = false
        // return false;
      }
    },
    showCommentTransition(CommentBtnPostID) {
      this.show3 = CommentBtnPostID
    },
    // getUserSelectedCommentReaction(str_Reaction, commentItem) {
    //     let isExist = !this.isNull(commentItem.commentReactions) ? commentItem.commentReactions.filter(x => x.PoReaCreatedBy === Cookies.get("userIDSession") && x.PoReaType.toUpperCase() === str_Reaction) : false;
    //     return isExist;
    // },

    getCommentReactionCount(str_Reaction, commentItem) {
      // setInterval(() => {
      //     DataSource.shared.getPostReaction(commentItem.PoCmID).then((result) => {
      //         this.$set(this.post.commentItems, "commentReaction", result.Table)
      //     });
      // }, 2000);

      let int_ReactionCount = !this.isNull(commentItem.commentReactions)
        ? commentItem.commentReactions.filter(x => x.PoReaType.toUpperCase() === str_Reaction).length
        : 0
      return int_ReactionCount
      /*
        let int_ReactionCount = !this.isNull(commentItem.commentReaction) ? commentItem.commentReaction.filter(x => x.PoReaType.toUpperCase() === str_Reaction).length : 0;

        return int_ReactionCount*/
    },

    // toggleCommentReaction(e, commentItem) {
    //     let reaction = $(e.target).val();
    //     let isChecked = $(e.target).prop("checked");
    //
    //     $(e.target).closest("td").siblings("td").find("input[type='checkbox']").prop("checked", false);
    //
    //     DataSource.shared.updatePostReaction(commentItem.PoCmID, "DELETE")
    //         .then(() => {
    //             $(e.target).closest("tr").find("td").removeClass("checked");
    //
    //             if (isChecked) {
    //                 $(e.target).closest("td").addClass("checked");
    //                 return DataSource.shared.savePostReaction(commentItem.PoCmID, reaction, "POST");
    //             }
    //         });
    //
    //     /*$(e.target).closest("td").siblings("td").find("input[type='checkbox']").prop("checked", false);
    //     DataSource.shared.updatePostReaction(commentItem.PoCmID, "DELETE")
    //         .then(() => {
    //             $(e.target).closest("tr").find("td").removeClass("checked");
    //
    //             if (isChecked) {
    //                 $(e.target).closest("td").addClass("checked");
    //                 DataSource.shared.savePostReaction(commentItem.PoCmID, reaction, "COMMENT");
    //             }
    //         });*/
    // },

    // getUserSelectedReaction(str_Reaction) {
    //     let isExist = !this.isNull(this.post.postReaction) ? this.post.postReaction.filter(x => Cookies.get("userIDSession") && x.PoReaType.toUpperCase() === str_Reaction).length : 0;
    //     return isExist;
    // },

    getPostReactionCount(str_Reaction) {
      let isExist = !this.isNull(this.post.postReaction)
        ? this.post.postReaction.filter(x => x.PoReaCreatedBy === Cookies.get('userIDSession') && x.PoReaType.toUpperCase() === str_Reaction).length
        : 0
      return isExist
      let reactionCount = this.post.postReaction.length
    },

    // togglePostReaction(e) {
    //     let reaction = $(e.target).val();
    //     let isChecked = $(e.target).prop("checked");
    //     $(e.target).closest("td").siblings("td").find("input[type='checkbox']").prop("checked", false);
    //
    //     DataSource.shared.updatePostReaction(this.post.PostID, "DELETE")
    //         .then(() => {
    //             $(e.target).closest("tr").find("td").removeClass("checked");
    //
    //             if (isChecked) {
    //                 $(e.target).closest("td").addClass("checked");
    //                 return DataSource.shared.savePostReaction(this.post.PostID, reaction, "POST");
    //             }
    //         })
    //         .then(() => {
    //             DataSource.shared.getPostReaction(this.post.PostID).then((result) => {
    //                 this.$set(this.post, "postReaction", result.Table);
    //             });
    //         });
    // },

    /*#region Download Item Functions*/
    pause(msec) {
      return new Promise((resolve, reject) => {
        setTimeout(resolve, msec || 1000)
      })
    },
    getDownloadFile(url) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url,
          responseType: 'arraybuffer',
        })
          .then(data => {
            resolve(data.data)
          })
          .catch(error => {
            reject(error.toString())
          })
      })
    },
    downloadItem(val) {
      // this.isLoad = true;
      // if (val && val.length > 5) {
      this.$notify({
        title: lang('Downloading...'),
        dangerouslyUseHTMLString: true,
        message: `${lang('Download is in progress, Please don’t close the browser or click to other pages until the download completed')}`,
        iconClass: 'el-icon-loading',
        duration: 0,
      })
      const zip = new JSZip()
      const promises = []
      val.forEach((url, index) => {
        const promise = this.getDownloadFile(url.oriFilePath).then(data => {
          let nameList = url.oriFilePath.split('.')
          let fileName = index + '.' + nameList[nameList.length - 1]
          zip.file(fileName, data, { binary: true })
        })
        promises.push(promise)
      })

      Promise.all(promises).then(() => {
        this.$notify.closeAll()
        zip.generateAsync({ type: 'blob' }).then(content => {
          FileSaver.saveAs(content, new Date().getTime())
        })
      })
      // } else {
      //   var indexA = 1
      //   for (let obj_SelectedItem of val) {
      //     let a = document.createElement('a')
      //     if (obj_SelectedItem.blobFilePath) {
      //       a.href = obj_SelectedItem.blobFilePath
      //     } else {
      //       a.href = obj_SelectedItem.FilePath
      //     }
      //     // a.href = obj_SelectedItem.FilePath;
      //     a.target = '_blank'
      //     a.download = ('download-' + indexA + obj_SelectedItem.PostItemFileExt).toString()
      //     a.style.display = 'none'
      //     document.body.appendChild(a)
      //     a.click()
      //     a.remove()
      //     indexA++
      //   }
      // }
      // this.isLoad = false
    },
    async downloadSingleItem(obj_SelectedItem) {
      // this.$vs.loading()
      let a = document.createElement('a')
      if (obj_SelectedItem.blobFilePath) {
        a.href = obj_SelectedItem.blobFilePath
      } else {
        a.href = obj_SelectedItem.FilePath
      }
      // a.href = obj_SelectedItem.FilePath;
      a.download = ('download-1' + obj_SelectedItem.PostItemFileExt).toString()
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
      // this.$vs.loading.close();
    },
    getContentType(e) {
      let contentType = ''

      switch (e.GalFileExt.toUpperCase()) {
        case '.PDF':
          contentType += 'application/octet-stream'
          break
        default:
          contentType += e.GalFileType
          break
      }

      return contentType
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      //Credit to Jeremy Banks @ stackoverflow
      contentType = contentType || ''
      sliceSize = sliceSize || 512

      let byteCharacters = atob(b64Data)
      let byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize)

        let byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        let byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      return new Blob(byteArrays, { type: contentType })
    },
    /*#endregion*/
    async initPost() {
      this.isLoad = true
      this.obj_SelectedReaction = []

      /*this.resetPost();*/
      // let tempobj = !this.isNull(this.post.PostID) ? this.post : this.parentPost;
      this.post = this.parentPost
      // let promise_GetPostFile = await DataSource.shared.getPostFile(this.post.PostID);
      let promise_GetPostFile = DataSource.shared.getPostFileReturnFilePath(this.post.PostID)
      let promise_GetPostReaction = DataSource.shared.getPostReaction(this.post.PostID)
      let promise_GetPostKeyTag = DataSource.shared.getPostKeyTag(this.post.PostID)

      let promise_GetPostDevelopmentGoals = DataSource.shared.getPostDevelopmentGoals(this.post.PostID)
      let promise_GetPostSeen = DataSource.shared.getPostSeen(this.post.PostID)

      // this.post.PostContent = this.replaceWithLink(this.post.PostContent);

      if (this.post.ProfileImage !== '') {
        this.post.oriProfileImage = this.post.ProfileImage
        await this.urltoFile(this.post.ProfileImage, '', '')
          .then(blobFile => {
            var url = window.URL.createObjectURL(blobFile)

            this.post.ProfileImage = url
          })
          .finally(() => {
            // this.getImagePreviews();
          })
      }

      await Promise.all([promise_GetPostFile, promise_GetPostReaction, promise_GetPostKeyTag, promise_GetPostDevelopmentGoals, promise_GetPostSeen])
        // await Promise.all([promise_GetPostFile, promise_GetPostReaction])
        .then(result => {
          if (result[0].Table) {
            result[0].Table.forEach(file => {
              file.numPages = undefined

              // if (this.isVideo(file)) {
              //     var thumbnail = this.generateVideoThumbnail(file.FilePath);
              //     file.videoThumbnail = thumbnail;
              // }

              if (file.PostItemFileExt.toLowerCase() === '.pdf') {
                // let src = pdf.createLoadingTask(`data:`+file.PostItemFileType+`;base64, ${file.PostItemFile}`);
                let src = pdf.createLoadingTask(file.FilePath)
                file.pageOfSrc = src
                src.promise.then(pdf => {
                  file.numPages = pdf.numPages
                })
              }
              file.oriFilePath = file.FilePath
              // if (this.isImageByExt(file)) {
              //   var filename = file.PostItemID + file.PostItemFileExt;
              //   this.urltoFile(file.FilePath, filename, file.PostItemFileType).then((blobFile) => {
              //     var url = window.URL.createObjectURL(blobFile);
              //     // var img = new Image();
              //
              //     file.FilePath = url;
              //   }).finally(() => {
              //     // this.getImagePreviews();
              //   });
              // }
              //
              // if (this.isVideo(file)) {
              //   var filename = file.PostItemID + file.PostItemFileExt;
              //   this.urltoFile(file.FilePath, filename, file.PostItemFileType).then((blobFile) => {
              //     var url = window.URL.createObjectURL(blobFile);
              //     // var img = new Image();
              //
              //     file.blobFilePath = url;
              //   }).finally(() => {
              //     // this.getImagePreviews();
              //   });
              // }
            })
          }

          this.$set(this.post, 'postFiles', result[0].Table)
          this.$set(this.post, 'collapsed', true)
          this.$set(this.post, 'postReaction', result[1].Table)

          this.$set(this.post, 'postKeyTag', result[2].Table)
          this.$set(this.post, 'postDevelopment', result[3].Table)
          this.$set(this.post, 'postSeen', result[4].Table)

          // this.getComment();
          const countImageFile = this.post && this.post.postFiles && this.post.postFiles.length
          this.$set(this.post, 'countImageFile', countImageFile)

          this.remainingImage = this.post.countImageFile - 4

          this.isLoad = false
        })

      await this.sleep(200)

      if (this.post.postReaction !== undefined) {
        this.post.postReaction.forEach(object => {
          if (Cookies.get('userIDSession') === object.PoReaCreatedBy) {
            this.obj_SelectedReaction.push(object)
          }
        })
      }

      if (this.post.postDevelopment?.length > 0) {
        let newGoalList = []
        this.post.postDevelopment.forEach(x => {
          const exist = newGoalList.find(d => d.Domain === x.PostUpLMDomain)
          if (exist) {
            exist.ItemList.push(x)
          } else {
            newGoalList.push({
              Domain: x.PostUpLMDomain,
              ItemList: [x],
            })
          }
        })
        this.post.PostLearningMomentsGrouping = newGoalList
      }
      this.$emit('loadingclose', 'false')
      // setInterval(() => {
      await this.getComment()

      //     }, 3000);
    },

    initCommentInterval() {
      /* setInterval(() => {
             this.getComment;
         },
            3000);*/
      /*  setTimeout(
              this.getComment
              , 3000);*/
      /* if (!this.isNull(comments.Table)) {
             for (let i = 0; i < comments.Table.length; i++)
                 setInterval(() => {
                     DataSource.shared.getPostReaction(comments.Table[i].PoCmID).then((commentReactions) => {
                         this.$set(this.post.commentItems[i], "commentReactions", commentReactions.Table);
                     });
                 }, 5000);
         }*/
      /*this.$set(this.post, "commentPostID", this.post.PostID);
        this.$set(this.post, "commentItems", result[1].Table);*/
      /*for(let comment of this.post.commentItems){
        }*/
    },
    async getComment() {
      await DataSource.shared.getComment(this.post.PostID).then(comments => {
        if (comments.Table && comments.Table.length > 0) {
          comments.Table.sort((a, b) => {
            if (Date.parse(a.PoCmCreatedDate) > Date.parse(b.PoCmCreatedDate)) {
              return -1
            } else if (Date.parse(a.PoCmCreatedDate) < Date.parse(b.PoCmCreatedDate)) {
              return 1
            } else {
              return 0
            }
          })
        }

        this.$set(this.post, 'commentItems', comments.Table)

        if (!this.isNull(this.post.commentItems)) {
          for (let i = 0; i < this.post.commentItems.length; i++) {
            DataSource.shared.getPostReaction(comments.Table[i].PoCmID).then(commentReactions => {
              this.commentReactionSelected = 0

              if (commentReactions.Table) {
                commentReactions.Table.commentReactionSelected = commentReactions.Table.filter(x => Cookies.get('userIDSession') === x.PoReaCreatedBy).length

                this.$set(this.post.commentItems[i], 'commentReactions', commentReactions.Table)
              }
            })
          }

          this.commentCount = this.post.commentItems.length
        } else {
          this.commentCount = '0'
        }
      })
    },

    isNull(obj) {
      return obj === null || obj === undefined || obj === 'undefined' || obj.length === 0 || obj === ''
    },
    isImageByExt(obj_File) {
      let ext = String(obj_File.PostItemFileExt).toUpperCase()
      let isImage = false

      switch (ext) {
        case '.PNG':
        case '.JPG':
        case '.BMP':
        case '.GIF':
        case '.JPEG':
          isImage = true
          break
        default:
          isImage = false
          break
      }

      return isImage
    },
    // getLowSource(file) {
    //     return `data:image/jpg;base64, ${file.PostItemFileLow}`;
    // },
    getMediumSource(file) {
      let SourceisImage = this.isImageByExt(file)
      if (SourceisImage === true) {
        return `data:image/jpg;base64, ${file.PostItemFileMedium}`
      } else {
        return `data:application/pdf;base64, ${file.PostItemFile}`
      }
    },
    getFile(file) {
      return `data:${file.PostItemFileType};base64,${file.PostItemFile}`
    },
    submitComment(commentPostID) {
      this.$emit('commentitemSubmit', commentPostID, this.commentPostContent)
      // this.sendMsg(commentPostID,this.commentPostContent);
      // this.getBCMsg(commentPostID);
      this.commentPostContent = ''
    },
    saveClick(PoCmID, PoCmContent) {
      this.readonly = true
      this.showEdit = true
      this.checkidcomment = null

      this.$emit('commentEdit', PoCmID, PoCmContent)
    },
    emitShowDeleteModal(deleteCmId, deleteCmContent, deleteCmPostId, post) {
      this.deleteCmId = deleteCmId
      this.deleteCmContent = deleteCmContent
      this.deleteCmPostId = deleteCmPostId
      this.$emit('showDeleteModal', this.deleteCmId, this.deleteCmContent, this.deleteCmPostId, post)
    },
    closeDeleteModal() {
      this.deleteModalShow = false
    },
    editClick(PoCmID) {
      this.showEdit = false
      this.readonly = false
      this.checkidcomment = PoCmID
    },
    deleteComment() {
      this.$emit('commentDelete', this.deleteCmId, this.deleteCmContent, this.deleteCmPostId)
      this.closeDeleteModal()
    },
    removePost(post) {
      $('#single-post-dropdown').trigger('click')

      this.deletePost(post)
      // this.$emit("deletePost", post);
    },
    deletePost(post) {
      DataSource.shared.softDeletePost(post.PostID).then(result => {})
      this.sleep(200) // changes (add for wait a while only delete)
      this.$emit('loadPosts')
    },
    editPost(post) {
      this.$vs.loading()
      $('#single-post-dropdown').trigger('click')

      var curPostStutus = ''
      if (post.PostStatus === 'Draft') {
        curPostStutus = post.PostStatus
      }

      DataSource.shared.getPostAllTaggingStudentsByPostID(post.PostID, curPostStutus).then(result => {
        this.post.arrobj_SelectedStudents = result.Table

        switch (this.post.PostType.toUpperCase()) {
          case 'PORTFOLIO':
            this.obj_SelectedComponent = portfolio
            break
          case 'UPDATE':
            this.obj_SelectedComponent = updates
            break
          case 'BROADCAST':
            this.obj_SelectedComponent = broadcast
            break
        }

        this.showEditModal()
      })
    },
    showEditModal() {
      this.$refs.modal_EditComponent.show()
      this.$vs.loading.close()
    },
    hideEditModal() {
      this.obj_SelectedComponent = false
      this.$refs.modal_EditComponent.hide()
    },
    async displayResult(value) {
      if (value == 'TRUE') this.result = 'Successfully posted'
      else this.result = 'Something went wrong. Please inform the adminstrator'

      await this.sleep(300)
      this.hideEditModal()
      this.$emit('loadPosts')
    },
    // checkIfImage(file) {
    //     return isImage(file);
    // },
    // async commentEdit(PoCmID, PoCmContent) {
    //     this.error = "";
    //     //this.results = "<< Requesting.. >>";
    //     try {
    //
    //         this.commentPostID = PoCmID;
    //         this.commentPostContent = PoCmContent;
    //         this.actionMode = "Edit";
    //         const commentResponse = await DataSource.shared.saveClick(this.commentPostID, this.commentPostContent, this.actionMode);
    //         if (commentResponse) {
    //             switch (commentResponse.code) {
    //                 case "1":
    //                     // reset all input filed to blank
    //                     this.commentPostID = null;
    //                     this.commentPostContent = "";
    //                     this.readonly = true;
    //                     // this.results = `Post Submitted`;
    //                     // this.success = 'Post Submitted, activity will be active in a while';
    //                     break;
    //                 case "88":
    //                     this.results = `Please Login to submit post`;
    //                     this.systemmsgError = true;
    //                     break;
    //                 case "99":
    //                     this.results = `Please fill in content`;
    //                     this.systemmsgError = true;
    //                     break;
    //                 // default:
    //                 //     alert("Please try again later");
    //                 //     this.results = JSON.stringify(response);
    //             }
    //         }
    //     } catch (e) {
    //         console.log(e);
    //         this.error = e;
    //     }
    // },
    // async commentEdit(PoCmID, PoCmContent) {
    //     this.error = "";
    //     //this.results = "<< Requesting.. >>";
    //     try {
    //
    //         this.commentPostID = PoCmID;
    //         this.commentPostContent = PoCmContent;
    //         this.actionMode = "Edit";
    //         const commentResponse = await DataSource.shared.saveClick(this.commentPostID, this.commentPostContent, this.actionMode);
    //         if (commentResponse) {
    //             switch (commentResponse.code) {
    //                 case "1":
    //                     // reset all input filed to blank
    //                     this.commentPostID = null;
    //                     this.commentPostContent = "";
    //                     this.readonly = true;
    //                     // this.results = `Post Submitted`;
    //                     // this.success = 'Post Submitted, activity will be active in a while';
    //                     break;
    //                 case "88":
    //                     this.results = `Please Login to submit post`;
    //                     this.systemmsgError = true;
    //                     break;
    //                 case "99":
    //                     this.results = `Please fill in content`;
    //                     this.systemmsgError = true;
    //                     break;
    //                 // default:
    //                 //     alert("Please try again later");
    //                 //     this.results = JSON.stringify(response);
    //             }
    //         }
    //     } catch (e) {
    //         console.log(e);
    //         this.error = e;
    //     }
    // },

    mouseOver: function () {
      this.isHoverReaction = !this.isHoverReaction
    },
    checkReactionIcon(iconName) {
      let reactionIcon = ''
      // let iconName = reaction.PoReaType;

      if (iconName === 'LIKE') {
        reactionIcon = reactionLike
      } else if (iconName === 'LOVE') {
        reactionIcon = reactionLove
      } else if (iconName === 'WOW') {
        reactionIcon = reactionWow
      } else if (iconName === 'HAHA') {
        reactionIcon = reactionFunny
      } else if (iconName === 'SAD') {
        reactionIcon = reactionSad
      }

      return reactionIcon
    },
    checkReactionIconName(iconName) {
      let reactionIconName = ''

      if (iconName === 'LIKE') {
        reactionIconName = lang('LIKE')
      } else if (iconName === 'LOVE') {
        reactionIconName = lang('LOVE')
      } else if (iconName === 'WOW') {
        reactionIconName = lang('WOW')
      } else if (iconName === 'HAHA') {
        reactionIconName = lang('HAHA')
      } else if (iconName === 'SAD') {
        reactionIconName = lang('SAD')
      }

      return reactionIconName
    },
    togglePostReaction(e) {
      let reaction = $(e.target).val()
      let isChecked = $(e.target).prop('checked')
      this.obj_SelectedReaction = []

      DataSource.shared
        .updatePostReaction(this.post.PostID, 'DELETE')
        .then(() => {
          if (isChecked) {
            return DataSource.shared.savePostReaction(this.post.PostID, reaction, 'POST')
          }
        })
        .then(() => {
          DataSource.shared.getPostReaction(this.post.PostID).then(result => {
            this.$set(this.post, 'postReaction', result.Table)

            // if (this.post.postReaction !== undefined) {
            //     this.post.postReaction.forEach(object => {
            //         if (Cookies.get('userIDSession') === object.PoReaCreatedBy) {
            //             this.obj_SelectedReaction.push(object);
            //         }
            //     });
            // }
          })

          this.$emit('sendMsg', this.post.PostID, this.post.PostContent)
        })
    },
    getUserSelectedReaction(str_Reaction) {
      let isExist = !this.isNull(this.post.postReaction)
        ? this.post.postReaction.filter(x => Cookies.get('userIDSession') === x.PoReaCreatedBy && x.PoReaType.toUpperCase() === str_Reaction).length
        : 0
      return isExist
    },

    mouseOverComment: function (postCommentID) {
      $('#' + postCommentID + '-comment-reaction-list').css('display', 'block')
    },
    mouseLeaveComment: function (postCommentID) {
      $('#' + postCommentID + '-comment-reaction-list').css('display', 'none')
    },
    toggleCommentReaction(e, commentItem) {
      let reaction = $(e.target).val()
      let isChecked = $(e.target).prop('checked')
      this.obj_SelectedCommentReaction = []

      DataSource.shared
        .updatePostReaction(commentItem.PoCmID, 'DELETE')
        .then(() => {
          if (isChecked) {
            return DataSource.shared.savePostReaction(commentItem.PoCmID, reaction, 'POST')
          }
        })
        .then(() => {
          // this.$emit('commentEdit', commentItem.PoCmID, commentItem.PoCmContent);
          this.$emit('sendMsg', commentItem.PoCmPosID, commentItem.PoCmContent)
          // this.getBCMsg(commentItem.PoCmID);
        })
    },
    getUserSelectedCommentReaction(str_Reaction, commentItem) {
      let isExist = !this.isNull(commentItem.commentReactions)
        ? commentItem.commentReactions.filter(x => Cookies.get('userIDSession') === x.PoReaCreatedBy && x.PoReaType.toUpperCase() === str_Reaction).length
        : 0
      return isExist
    },
    reactionGroupby(objReaction, key) {
      const result = {}
      if (objReaction && objReaction.length) {
        objReaction.forEach(item => {
          if (!result[item[key]]) {
            result[item[key]] = []
          }
          result[item[key]].push(item)
        })
      }

      return result
    },

    isVideo(obj_File) {
      let ext = String(obj_File.PostItemFileExt).toUpperCase()
      let isVideo = false

      switch (ext) {
        case '.MP4':
        case '.MOV':
          isVideo = true
          break
        default:
          isVideo = false
          break
      }

      return isVideo
    },

    isAudio(obj_File) {
      let ext = String(obj_File.PostItemFileExt).toUpperCase()
      let isAudio = false

      switch (ext) {
        case '.MP3':
        case '.AAC':
        case '.WAV':
        case '.M4A':
          isAudio = true
          break
        default:
          isAudio = false
          break
      }

      return isAudio
    },

    convertDatetimeFormat(orgDate) {
      return moment(orgDate).format('DD/MM/YYYY HH:mm:ss')
    },

    showReactionModal() {
      this.$refs['reactionModal'].show()
    },
    hideReactionModal() {
      this.$refs['reactionModal'].hide()
    },

    async submitDM(post) {
      // console.log(this.parentDMMsg, "DM msg", postID);
      if (this.parentDMMsg === '') {
        this.$notify.error({
          title: 'Error',
          message: 'Please enter some message!',
        })
        return
      }

      try {
        this.$vs.loading()

        this.singlePostLink = ''

        if (post.PostID !== '') {
          $('.dm-container').css('display', 'none')

          if (post.ProfileImage !== '') {
            $('#profile_' + post.PostID).attr('src', post.oriProfileImage)
          }

          if (!this.isNull(post.postFiles)) {
            post.postFiles.forEach(file => {
              $('#ITEMPOSTID_' + file.PostItemID).attr('src', file.oriFilePath)
            })
          }

          this.singlePostLink = $('.feed-box.' + post.PostID)[0].outerHTML
        }

        const dmResponse = await DataSource.shared.savePostDM(post.PostID, '', this.parentDMMsg, encodeURI(this.singlePostLink))

        if (dmResponse) {
          if (dmResponse.code === '2') {
            this.$notify.error({
              title: 'Error',
              message: 'No record found',
            })
          } else if (dmResponse.code === '88') {
            window.location.replace('/')
          } else if (dmResponse.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Please try again later',
            })
          } else {
            this.$notify({
              title: lang('Success'),
              message: 'Message send successful!',
              type: 'success',
            })
          }
        }

        this.parentDMMsg = ''
        $('.dm-container').css('display', 'block')

        if (post.ProfileImage !== '') {
          $('#profile_' + post.PostID).attr('src', post.ProfileImage)
        }

        if (!this.isNull(post.postFiles)) {
          post.postFiles.forEach(file => {
            $('#ITEMPOSTID_' + file.PostItemID).attr('src', file.FilePath)
          })
        }

        this.$vs.loading.close()
      } catch (e) {
        console.log(e)
      }
    },

    replaceWithLink(val) {
      const URLMatcher =
        /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim

      const withLinks = val.replace(URLMatcher, match => `<a href="${match}" target="_blank">${match}</a>`)
      return withLinks
    },

    urltoFile(url, filename, mimeType) {
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer()
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType })
        })
    },

    showPostSeenModal() {
      this.$refs['postSeenModal'].show()
    },
    hidePostSeenModal() {
      this.$refs['postSeenModal'].hide()
    },

    generateVideoThumbnail(thumbnail) {
      var src = thumbnail ///video url not youtube or vimeo,just video on server
      var video = document.createElement('video')

      video.src = src

      video.width = 360
      video.height = 240

      var canvas = document.createElement('canvas')
      canvas.width = 360
      canvas.height = 240
      var context = canvas.getContext('2d')

      context.drawImage(video, 0, 0, canvas.width, canvas.height)
      var dataURI = canvas.toDataURL('image/jpeg')

      return dataURI
    },
    getHelperBase(obj_Images) {
      return getActivityImageBase(obj_Images)
    },
    triggerClickVideo(videoFile, itemID) {
      if ($('.video-thumbnail-' + itemID + ' img').length > 0) {
        this.videoClick = true
        $('.video-thumbnail-' + itemID + ' img').remove()

        var video = document.createElement('video')

        video.className = 'video-thumb nonM card-img-top d-block img-fluid w-100'
        video.src = videoFile.FilePath

        var videoHtml = ''
        videoHtml +=
          "<video class='video-thumb nonM card-img-top d-block img-fluid w-100' style='object-fit: contain; margin: 0px; height: 100%;' controls autoplay src='" +
          videoFile.FilePath +
          "' type='video/mp4' controlsList='nodownload'>"
        // videoHtml += "<source :src='"+videoFile.FilePath+"' type='video/mp4'>";
        videoHtml += '</video>'

        if ($('.video-thumbnail-' + itemID + ' video').length <= 0) {
          $('.video-thumbnail-' + itemID).append(videoHtml)
          this.videoClick = false
        }

        // var filename = videoFile.PostItemID + videoFile.PostItemFileExt;
        // this.urltoFile(videoFile.FilePath, filename, videoFile.PostItemFileType).then((blobFile) => {
        //     var url = window.URL.createObjectURL(blobFile);
        //     // var img = new Image();
        //
        //     videoFile.FilePath = url;
        //
        //     // this.getImagePreviews();
        //     $(".video-thumbnail-"+itemID+" img").remove();
        //
        //     var video = document.createElement('video');
        //
        //     video.className = "video-thumb nonM card-img-top d-block img-fluid w-100";
        //     video.src = videoFile.FilePath;
        //
        //     var videoHtml = "";
        //     videoHtml += "<video class='video-thumb nonM card-img-top d-block img-fluid w-100' style='object-fit: contain; margin: 0px; height: 100%;' controls autoplay src='"+videoFile.FilePath+"' type='video/mp4' controlsList='nodownload'>";
        //     // videoHtml += "<source :src='"+videoFile.FilePath+"' type='video/mp4'>";
        //     videoHtml += "</video>";
        //
        //     if ($(".video-thumbnail-"+itemID+" video").length <= 0) {
        //         $(".video-thumbnail-"+itemID).append(videoHtml);
        //     }
        // }).finally((result) => {
        //     this.videoClick = false;
        // });
      }
    },

    showPostDevelopmentModal() {
      this.$refs['postDevelopmentModal'].show()
    },
    hidePostDevelopmentModal() {
      this.$refs['postDevelopmentModal'].hide()
    },

    showDivs(type) {
      if (type === 'default') {
        this.currentSlide = this.imgModalSlide + 1
      } else if (type === 'prev') {
        this.currentSlide = this.currentSlide - 1
        if (this.currentSlide < 1) {
          this.currentSlide = this.post.postFiles.length
        }
      } else if (type === 'next') {
        this.currentSlide = this.currentSlide + 1
        if (this.currentSlide > this.post.postFiles.length) {
          this.currentSlide = 1
        }
      }
      this.post.postFiles.forEach((iFiles, iIndex) => {
        iFiles.isSlide = false

        if (this.currentSlide === iIndex + 1) {
          iFiles.isSlide = true
        }
      })
      this.$forceUpdate()
    },
  },
  created() {
    this.userType = Cookies.get('userTypeSession')

    if (this.userType === 'Parent') {
      let schID = Cookies.get('schoolSession')
      let schIDs = JSON.parse(schID)
      schIDs = schIDs.Table

      this.arr_SchIDs = []
      schIDs.forEach((object, index) => {
        this.arr_SchIDs.push(object.SCH_Ids)
      })
    }

    window.addEventListener('resize', this.isMobile)
  },
  destroyed() {
    window.removeEventListener('resize', this.isMobile)
  },
}
</script>

<style scoped>
.reaction-popover,
.comment-reaction-popover {
  display: inline-block;
}

.comment-reaction-popover label {
  font-weight: normal;
  cursor: pointer;
  color: #0d54af;
}

.comment-reaction-popover .comment-selected {
  font-weight: bold;
  cursor: pointer;
  color: #0d54af;
}

.reaction-label {
  cursor: pointer;
  margin: 0px;
}

.reaction-popover:hover > .reaction-list-container {
  opacity: 1;
  /*background: red;*/
}

.total-each-comment-reaction {
  display: inline-block;
}

.reaction-list-container {
  background: white;
  /*display: none;*/
  position: absolute;
  /*left: 0px;*/
  top: -35px;
  /*opacity: 0;*/
  border-radius: 60px;

  /*width: 200px;*/
  /*left: -130px;*/
  width: 160px;
  /*left: -100px;*/
  z-index: 999;
}

.reaction-function-container.left .reaction-list-container {
  left: 0px;
}

.reaction-function-container .reaction-list-container {
  right: 0px;
}

.comment-reaction-list-container {
  display: none;
  background: white;
  /*display: none;*/
  position: absolute;
  left: 0px;
  top: -40px;
  /*opacity: 0;*/
  border-radius: 60px;
}

.single-reaction,
.single-comment-reaction {
  display: inline-block;
  cursor: pointer;
  padding: 5px;
  background: transparent;
  transition: 0.2s ease;
  text-align: center;
}

.single-reaction label,
.single-comment-reaction label {
  margin: 0px;
}

.single-reaction:hover,
.single-comment-reaction:hover {
  transform: scale(1.5);
}

.single-reaction:hover p,
.single-comment-reaction:hover p {
  opacity: 1;
  font-size: 12px;
  font-weight: normal;
}

.single-reaction img,
.single-comment-reaction img {
  width: 30px;
  border-radius: 20px;
}

.single-reaction p,
.single-comment-reaction p {
  opacity: 0;
  position: absolute;
  margin: 0px 0px 0px 3px;
  top: -15px;
}

.feed-box {
  /*background: #f0f0f0;*/
  /*border: 1px solid #f0f0f0;*/
  /*background: #F6F8FB;*/
  background: #ffffff;
  border-radius: 6px;
}

.comment_wrapper {
  background: white;

  padding: 0px;
}

.comment_wrapper form {
  border: unset;
  border-radius: unset;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}

.moreAction {
  text-align: left;
  /*padding: 10px;*/
  position: relative;
}

.total-reaction-container {
  text-align: left;
  position: relative;
  /*padding: 5px 10px;*/
  padding: 5px 55px 5px 10px;
  margin-bottom: 5px;
}

.total-reaction-img-list {
  width: 20px;
  /*background: transparent;*/
  border-radius: 60px;
}

.selected-reaction-icon {
  width: 20px;
  border-radius: 20px;
}

.comment-count {
  position: absolute;
  top: 10px;
  right: 10px;
}

.profile img {
  /*width: 50px;*/
  /*height: 50px;*/
  width: 40px;
  height: 40px;
  border-radius: 50%;
  /*object-fit: cover;*/
  object-fit: contain;
}

.commentProfile {
  width: 70px;
  position: relative;
  display: inline-block;
  vertical-align: top;
  text-align: center;
}

.commentProfile img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.rightCommentContainer {
  display: inline-block;
  /*width: 85%;*/
}

.comment__item {
  font-size: 12px;

  background: unset;
}

@media (max-width: 769px) {
  .rightCommentContainer {
    /*display: inline-block;*/
    /*width: 70%;*/
  }

  .feed-box .image-wrapper li.postFile__item:nth-child(n + 2) {
    width: 50%;
  }
}

@media (max-width: 450px) {
  .rightCommentContainer {
    /*display: inline-block;*/
    /*width: 70%;*/
  }

  .feed-box .image-wrapper li.postFile__item:nth-child(n + 2) {
    width: 100%;
  }
}

input[type='checkbox']:not(:checked) + label:after,
input[type='checkbox']:checked + label:after {
  content: unset;
}

.author {
  padding: 10px 10px 10px 20px;
}

.profile {
  width: 42px;
  height: 42px;
  margin-right: 10px;
}

#single-post-dropdown {
  padding: 5px;
}

.comment_wrapper .btn {
  color: #426dff;
}

.commentWrap {
  margin: 0px 0px 10px 0px;
}

.reaction-function-container {
  position: absolute;
  top: 5px;
  right: 10px;
}

.reaction-function-container.left {
  left: 10px;
}

.comment__name {
  margin-right: 5px;
}

.web-view .image-wrapper {
  /*background: #E1E6F0;*/
  background: #ffffff;
  width: 100%;
  height: 300px;
}

.mobile-view .image-wrapper {
  background: #e1e6f0;
  width: 100%;
  height: 200px;
}

.feed-box .image-wrapper li.postFile__item {
  width: 100%;
  margin: 0px;
  border: none;
}

.common-post-development-span {
  padding: 5px;
  display: inline-block;
  /*background: #0a74b7;*/
  color: #426dff;
  border-radius: 6px;
  font-size: 12px;
  border: 1px solid #426dff;
}

.image-grid-1 {
  display: grid;
  grid-column-gap: 3px;
  grid-row-gap: 3px;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-template-areas: 'img-1';
}

.image-grid-2 {
  display: grid;
  grid-column-gap: 3px;
  grid-row-gap: 3px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  grid-template-areas: 'img-1 img-2';
}

.image-grid-3 {
  display: grid;
  grid-column-gap: 3px;
  grid-row-gap: 3px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  grid-template-areas: 'img-1 img-2' 'img-1 img-3';
}

.image-grid-item-1 {
  grid-area: img-1;
  height: 300px !important;
}

.image-grid-item-2 {
  grid-area: img-2;
  height: 300px !important;
}

.image-grid-item-2-2 {
  grid-area: img-2;
  height: 150px !important;
}

.image-grid-item-3 {
  grid-area: img-3;
  height: calc(150px - 3px) !important;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}

.btn-single-download {
  position: absolute;
  top: 0;
  left: 0px;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
  border-radius: unset;
}

.mySlides {
  height: calc(100vh - 150px);
  width: 100%;
  overflow: auto;
}
</style>

<style>
.feed-box table {
  width: 100%;
}

.feed-box td,
.feed-box tr {
  border: 0px;
  vertical-align: middle;
}

#imageModal .modal-content {
  /*height: calc(100vh - 60px);*/
}

#imageModal .carousel-item {
  background: #222222 !important;
  height: calc(100vh - 100px);
}

.mobile-view #carousel1 .carousel-caption {
  position: unset;
  max-height: 100%;
  overflow: auto;
}

#imageModal .carousel-caption {
  position: unset;
  max-height: 100%;
  overflow: auto;
}

#imageModal .carousel-control-prev {
  top: 40px;
}

#feedList .mobile-view .feed-box .carousel .carousel-item {
  /*height: 100%;*/
  background: #222222 !important;
  height: 200px;
}

#feedList .carousel-inner {
  height: 100%;
}

#feedList .addComment span.input-span-placeholder {
  color: #91a3b6;
  font-size: 12px;
}

#feedList .commentItem__header div {
  flex: unset;
  display: flex;
}

.post-content ol,
.post-content ul {
  list-style-position: inside;
  padding-left: 1.5rem;
}
</style>
